import { z } from 'zod';
export const EXPLANATION_ROLES = ['S', 'V', 'O', 'C', 'M', 'CONJ', 'EX'];
export const ExplanationSchema = z
    .object({
    schemaVersion: z.literal(1),
    text: z.string().min(1).max(500),
    translationJa: z.string().min(1).max(700),
    patternJa: z.string().min(1).max(200),
    chunks: z
        .array(z.object({
        text: z.string().min(1).max(500),
        role: z.enum(EXPLANATION_ROLES),
        noteJa: z.string().min(1).max(500),
    }))
        .min(2)
        .max(18),
    points: z
        .array(z.object({
        quote: z.string().min(1).max(500),
        titleJa: z.string().min(1).max(120),
        bodyJa: z.string().min(1).max(900),
    }))
        .min(2)
        .max(5),
    clues: z
        .array(z.object({
        text: z.string().min(1).max(200),
        meaningJa: z.string().min(1).max(200),
        labelJa: z.string().min(1).max(100),
    }))
        .length(2),
})
    .superRefine((value, ctx) => {
    if (value.chunks.map((chunk) => chunk.text).join(' ') !== value.text)
        ctx.addIssue({ code: 'custom', message: 'Chunks must reconstruct the original sentence' });
    for (const point of value.points)
        if (!value.text.includes(point.quote))
            ctx.addIssue({
                code: 'custom',
                message: 'Grammar quote must occur in the original sentence',
            });
    for (const clue of value.clues)
        if (!value.text.toLowerCase().includes(clue.text.toLowerCase()))
            ctx.addIssue({
                code: 'custom',
                message: 'Answer clue must occur in the original sentence',
            });
});
//# sourceMappingURL=explanation.js.map